import * as yup from 'yup';

const validations = yup.object().shape({
  // twoFactorCode: yup.string().required(i18n.t('login-with-2fa.validations.twoFactorCode'))
});
// const validationsRecovery = yup.object().shape({
//   recoveryCode: yup.string().required(i18n.t('login-with-2fa.validations.recoveryCode'))
// });
export default validations;
